import { apiGet } from 'utils/API/actions/request'
import { USER_MESSAGE } from '../constants'

export const fetchUserMessage = (appid) => apiGet({
  entity: USER_MESSAGE,
  url: `/${appid}/messaging/clientcode`,
  isChainable: true
})
